import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { css } from "@vitality-ds/system";
import { BaseIconButton, BaseIconButtonLink } from "../../../IconButton/styled";
export default css(_defineProperty({
  display: "flex"
}, "".concat(BaseIconButtonLink, ", ").concat(BaseIconButton), {
  padding: "$xs"
}));